import filter from '../filters/filter';
import tagmanager from '../../abstracts/tagmanager.js';
import { isResponsiveScreen } from '../../abstracts/responsive.js';

const tourFilter = (filters) => ({
  ...filter(filters),

  afterInit() {
    this.watchAndCloseModal('filters.countryOrState', 'tourFilterModal_countryOrState');
    this.watchAndCloseModal('filters.region', 'tourFilterModal_region');
    this.watchAndCloseModal('filters.typeOrCategory', 'tourFilterModal_typeOrCategory');
  },

  searchAutoCompleteSelected(url) {
    tagmanager.event('comp_tour-searchbar_submit', {
      Category: 'tour',
      Selection: url,
    });

    window.location.href = url;
  },

  get sortedFilters() {
    return this.getSortedFilters();
  },

  search(value) {
    if (this.filters.search === value) {
      return;
    }

    this.filters.search = value;

    if (value !== '') {
      tagmanager.event('comp_tour-searchbar_submit', {
        Category: 'tour',
        Selection: false,
      });
    }

    if (isResponsiveScreen()) {
      history.back();
    }

    document.activeElement.blur();
  },
});

export default tourFilter;
